import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, RailzConnectDialogueHandler } from './types';
import UpdateGlobalPaymentsContext from './RailzConnectContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type GlobalPaymentsDialogueProps = {
  handleDialogue: DialogueHandler<RailzConnectDialogueHandler>;
};

type FC = FunctionComponent<GlobalPaymentsDialogueProps>;

const RailzConnectDialogue: FC = ({ handleDialogue }: GlobalPaymentsDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, error, payableName, receivableName, showConfirmUpdate } =
    useContext(UpdateGlobalPaymentsContext);
  const { t } = useTranslation('translations', {
    keyPrefix: 'AccountingSystem.AccountingSoftware.ChartOfAccount.Dialogs',
  });

  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title={t('UpdateError.title')}
          status="error"
          subTitle={`${error}`}
          confirm={{
            label: t('UpdateError.confirmButton'),
            action: () => handleDialogue({ type: 'error', state: 'success' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title={t('UpdateSuccess.subTitle')}
          width="577px"
          status="success"
          subTitle={t('UpdateSuccess.subTitle', { payableName, receivableName })}
          confirm={{
            label: t('UpdateSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'save', state: 'success' }),
          }}
          cancel={{
            label: t('UpdateSuccess.cancelButton'),
            action: () => handleDialogue({ type: 'save', state: 'error' }),
          }}
        />
        <ConfirmationDialogue
          isVisible={showConfirmUpdate}
          title={t('ConfirmChanges.title')}
          width="447px"
          status="none"
          subTitle={t('ConfirmChanges.subTitle')}
          confirm={{
            label: t('ConfirmChanges.confirmButton'),
            action: () => handleDialogue({ type: 'confirm', state: 'success' }),
          }}
          cancel={{
            label: t('ConfirmChanges.cancelButton'),
            action: () => handleDialogue({ type: 'confirm', state: 'error' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert, payableName, receivableName, error, showConfirmUpdate],
  );
};

export default RailzConnectDialogue;
